// The ProductDetails type is exploded out into enums describing keys to
// make Stripe metadata parsing & validation easier.
export var ProductDetailsStringProperties;
(function (ProductDetailsStringProperties) {
    ProductDetailsStringProperties[ProductDetailsStringProperties["name"] = 0] = "name";
    ProductDetailsStringProperties[ProductDetailsStringProperties["subtitle"] = 1] = "subtitle";
    ProductDetailsStringProperties[ProductDetailsStringProperties["successActionButtonLabel"] = 2] = "successActionButtonLabel";
    ProductDetailsStringProperties[ProductDetailsStringProperties["termsOfServiceURL"] = 3] = "termsOfServiceURL";
    ProductDetailsStringProperties[ProductDetailsStringProperties["termsOfServiceDownloadURL"] = 4] = "termsOfServiceDownloadURL";
    ProductDetailsStringProperties[ProductDetailsStringProperties["privacyNoticeURL"] = 5] = "privacyNoticeURL";
    ProductDetailsStringProperties[ProductDetailsStringProperties["privacyNoticeDownloadURL"] = 6] = "privacyNoticeDownloadURL";
    ProductDetailsStringProperties[ProductDetailsStringProperties["cancellationSurveyURL"] = 7] = "cancellationSurveyURL";
})(ProductDetailsStringProperties || (ProductDetailsStringProperties = {}));
export var ProductDetailsListProperties;
(function (ProductDetailsListProperties) {
    ProductDetailsListProperties[ProductDetailsListProperties["details"] = 0] = "details";
})(ProductDetailsListProperties || (ProductDetailsListProperties = {}));
// Do not re-order the list items without updating their references.
export const SUBSCRIPTION_TYPES = ['web', 'iap_google', 'iap_apple'];
export const MozillaSubscriptionTypes = {
    WEB: SUBSCRIPTION_TYPES[0],
    IAP_GOOGLE: SUBSCRIPTION_TYPES[1],
    IAP_APPLE: SUBSCRIPTION_TYPES[2],
};
export const PAYPAL_PAYMENT_ERROR_MISSING_AGREEMENT = 'missing_agreement';
export const PAYPAL_PAYMENT_ERROR_FUNDING_SOURCE = 'funding_source';
export const SubscriptionUpdateEligibility = {
    UPGRADE: 'upgrade',
    DOWNGRADE: 'downgrade',
    INVALID: 'invalid',
};
export var SubscriptionStripeErrorType;
(function (SubscriptionStripeErrorType) {
    SubscriptionStripeErrorType["NO_MIN_CHARGE_AMOUNT"] = "Currency does not have a minimum charge amount available.";
})(SubscriptionStripeErrorType || (SubscriptionStripeErrorType = {}));
export class SubscriptionStripeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'SubscriptionStripeError';
    }
}
